import _ from "lodash";
import React from "react";
import YouTube from "react-youtube";
import styled from "styled-components";

import { extractYoutube } from "@utils/extractYoutubeId";

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const YoutubeLive = ({
  attribute,
  width,
  height,
  playing = true,
  mute = false,
}) => {
  const opts = {
    height: height,
    width: width,
    playerVars: {
      autoplay: playing,
      mute: mute,
    },
  };

  const path = _.get(attribute, ["path"]);
  const youtubeId = extractYoutube({ path });
  console.log("youtubeId :>> ", youtubeId);
  return (
    <Container>
      <YouTube
        style={{ width: "100%", height: "100%" }}
        videoId={youtubeId}
        opts={opts}
      />
    </Container>
  );
};
